import React from 'react'
import CheckIcon from '@mui/icons-material/Check';
const AddJobSideBar = ({ active }) => {
	return (
		<div id='Sidenavbar'>
			<div id='SideBar__container' className='SideBar__container'>
				<div className='SideBar__JobSideBar'>
					<div className='SideBar__state__container'>
						<div className='SideBar__JobMenu'>1</div>
						<div className='vl'></div>
					</div>
					<div className='SideBar__JobMenu_state'>
						<div className='SideBar__JobMenu_state_header'>DEFINE</div>
						<div className='SideBar_state_circle_container'>
							{active >= 2 ? <CheckIcon className='coloricon' /> : <div className='SideBar_state_circle'></div>}
							<span className={active >= 2 ? 'SideBar_state_circle_text_active' : active === 1 ? 'SideBar_state_circle_text_active_move' : 'SideBar_state_circle_text'}>
								Job Profile</span>
						</div>
					</div>
				</div>
				<div className='SideBar__JobSideBar'>
					<div className='SideBar__state__container'>
						<div className='SideBar__JobMenu'>2</div>
						<div className='vl'></div>
					</div>
					<div className='SideBar__JobMenu_state'>
						<div className='SideBar__JobMenu_state_header'>DESCRIPTION</div>
						<div className='SideBar_state_circle_container'>
							{active >= 3 ? <CheckIcon className='coloricon' /> : <div className='SideBar_state_circle'></div>}
							<span className={active >= 3 ? 'SideBar_state_circle_text_active' : active === 2 ? 'SideBar_state_circle_text_active_move' : 'SideBar_state_circle_text'}> Job description</span>
						</div>
					</div>
				</div>
				<div className='SideBar__JobSideBar'>
					<div className='SideBar__state__container'>
						<div className='SideBar__JobMenu'>3</div>
						<div className='vl'></div>
					</div>
					<div className='SideBar__JobMenu_state'>
						<div className='SideBar__JobMenu_state_header'> RECRUITMENT SETTINGS</div>
						<div className='SideBar_state_circle_container'>
							{active >= 4 ? <CheckIcon className='coloricon' /> : <div className='SideBar_state_circle'></div>}
							<span className={active >= 4 ? 'SideBar_state_circle_text_active' : active === 3 ? 'SideBar_state_circle_text_active_move' : 'SideBar_state_circle_text'}>{' '} Recruitment settings</span>
						</div>
					</div>
				</div>
				<div className='SideBar__JobSideBar'>
					<div className='SideBar__state__container'>
						<div className='SideBar__JobMenu'>4</div>
						<div className='vl_two'></div>
					</div>
					<div className='SideBar__JobMenu_state'>
						<div className='SideBar__JobMenu_state_header'> APPLICANT FIELDS</div>
						<div className='SideBar_state_circle_container'>
							{active >= 5 ? <CheckIcon className='coloricon' /> : <div className='SideBar_state_circle'></div>}
							<span className={active >= 5 ? 'SideBar_state_circle_text_active' : active === 4 ? 'SideBar_state_circle_text_active_move' : 'SideBar_state_circle_text'}>{' '} Profile Info</span>
						</div>
						<div className='SideBar_state_circle_container'>
							{active >= 6 ? <CheckIcon className='coloricon' /> : <div className='SideBar_state_circle'></div>}
							<span className={active >= 6 ? 'SideBar_state_circle_text_active' : active === 5 ? 'SideBar_state_circle_text_active_move' : 'SideBar_state_circle_text'}>{' '} Education Details</span>
						</div>
						<div className='SideBar_state_circle_container'>
							{active >= 7 ? <CheckIcon className='coloricon' /> : <div className='SideBar_state_circle'></div>}
							<span className={active >= 7 ? 'SideBar_state_circle_text_active' : active === 6 ? 'SideBar_state_circle_text_active_move' : 'SideBar_state_circle_text'}>{' '} Experience Level</span>
						</div>
						<div className='SideBar_state_circle_container'>
							{active >= 8 ? <CheckIcon className='coloricon' /> : <div className='SideBar_state_circle'></div>}
							<span className={active >= 8 ? 'SideBar_state_circle_text_active' : active === 7 ? 'SideBar_state_circle_text_active_move' : 'SideBar_state_circle_text'}>{' '} Additional Details</span>
						</div>
					</div>
				</div>
				<div className='SideBar__JobSideBar'>
					<div className='SideBar__state__container'>
						<div className='SideBar__JobMenu'>5</div>
					</div>
					<div className='SideBar__JobMenu_state'>
						<div className='SideBar__JobMenu_state_header'> Summary</div>
						<div className='SideBar_state_circle_container'>
							<div className='SideBar_state_circle'></div>
							<span className={active >= 9 ? 'SideBar_state_circle_text_active' : active === 8 ? 'SideBar_state_circle_text_active_move' : 'SideBar_state_circle_text'}>{' '} Summary</span>
						</div>
					</div>
				</div>

			</div>

		</div>
	)
}

export default AddJobSideBar